import { render } from "./FilterPeppolOverview.vue?vue&type=template&id=f328c7b0&scoped=true"
import script from "./FilterPeppolOverview.vue?vue&type=script&lang=js"
export * from "./FilterPeppolOverview.vue?vue&type=script&lang=js"

import "./FilterPeppolOverview.vue?vue&type=style&index=0&id=f328c7b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f328c7b0"]])

export default __exports__